import { validateEmail } from '@perch-labs/warbler';
import { ValidatingInput, InputComponentProps } from '~/components/validating-input';
import { VALIDATE_EMAIL as VALIDATE } from '~/services/validate-email/validate-email.queries';

export const EmailTelesales = (props: InputComponentProps & { currentEmail: string }) => {
  const validate = async ({ apollo, value }) => {
    const { currentEmail } = props;

    if (!validateEmail(value)) return 'Please enter a valid email address';

    if (currentEmail !== value) {
      const { data } = await apollo.query({
        fetchPolicy: 'no-cache',
        query: VALIDATE,
        variables: { email: value },
      });

      if (data.validateEmail.userExists) return 'This email is already in use.';
    }

    return true;
  };

  return (
    <ValidatingInput
      autoComplete="username"
      label="Email"
      name="email"
      placeholder="example@arcadia.com"
      validate={validate}
      {...props}
    />
  );
};
